import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { DataTableComponent } from "../../../../shared/components";
import { Constants } from "../../../../shared/constants/constants";
import { TableButtonClicked } from "../../../../shared/models/data-table-model";

@Component({
  selector: "adaa-smart-tooltips-list",
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: "./smart-tooltips-list.html",
  styleUrl: "./smart-tooltips-list.scss",
})
export class SmartTooltipsListComponent {
  private _router = inject(Router);

  Constants = Constants;

  public getAction(value: TableButtonClicked) {
    switch (value.event) {
      case "edit":
        this._router.navigateByUrl(`/console/help/smart-tool-tips/edit/${value.data.searchKey}`);
        break;

      default:
        break;
    }
  }
}
